(function () {
  'use strict';

  const ROOT = '[data-product-tiles-root]';

  function buildPriceHtml(swatch, soldOutLabel) {
    const soldOut = swatch.getAttribute('data-swatch-unavailable') === 'true';
    if (soldOut) {
      return `<span class="price"><span class="sold-out">${soldOutLabel}</span></span>`;
    }

    const price = swatch.getAttribute('data-swatch-money-price');
    if (!price) return null;

    const compare = swatch.getAttribute('data-swatch-money-compare');
    if (compare) {
      return `<span class="price sale"><span class="new-price">${price}</span> <span class="old-price">${compare}</span></span>`;
    }

    return `<span class="price"><span class="new-price">${price}</span></span>`;
  }

  function bindItem(root, item) {
    const priceEl = item.querySelector('[data-product-price]');
    if (!priceEl) return;

    const soldOutLabel = root.getAttribute('data-sold-out-label') || 'Sold out';
    const defaultHtml = priceEl.innerHTML;

    const applyFromSwatch = (swatch) => {
      if (!item.contains(swatch)) return;
      const html = buildPriceHtml(swatch, soldOutLabel);
      if (html) priceEl.innerHTML = html;
    };

    const reset = () => {
      priceEl.innerHTML = defaultHtml;
    };

    item.addEventListener(
      'mouseenter',
      (e) => {
        const sw = e.target.closest('[data-swatch-button][data-swatch-money-price]');
        if (sw) applyFromSwatch(sw);
      },
      true
    );

    item.addEventListener('focusin', (e) => {
      const sw = e.target.closest('[data-swatch-button][data-swatch-money-price]');
      if (sw) applyFromSwatch(sw);
    });

    item.addEventListener('mouseleave', reset);
    item.addEventListener('focusout', (e) => {
      if (!item.contains(e.relatedTarget)) reset();
    });
  }

  function initRoot(root) {
    root.querySelectorAll('[data-grid-item]').forEach((item) => bindItem(root, item));
  }

  function init() {
    document.querySelectorAll(ROOT).forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
